import { render, staticRenderFns } from "./DevicesTab.vue?vue&type=template&id=584c49c7"
import script from "./DevicesTab.vue?vue&type=script&lang=js"
export * from "./DevicesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports